import script from "./ProductionCameras.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionCameras.vue?vue&type=script&setup=true&lang=js"

import "./ProductionCameras.vue?vue&type=style&index=0&id=3b72b4b5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b72b4b5"]])

export default __exports__